import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=3ba42929&scoped=true&"
import script from "./TermsList.vue?vue&type=script&lang=js&"
export * from "./TermsList.vue?vue&type=script&lang=js&"
import style0 from "./TermsList.vue?vue&type=style&index=0&id=3ba42929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba42929",
  null
  
)

export default component.exports